import { ReactElement, PropsWithChildren } from 'react';

import { IonItemGroup } from '@ionic/react';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormCheckboxGroupItem } from './FormCheckboxGroupItem/FormCheckboxGroupItem';
import { FormCheckboxGroupValidation } from './FormCheckboxGroup.types';
import { FormCheckboxGroupContext } from './FormCheckboxGroup.context';

interface FormRadioGroupProps<T = string>
  extends FormControlBaseProps<FormCheckboxGroupValidation, T> {}

type FormRadioGroupPropsWithChildren<T = string> = PropsWithChildren<
  FormRadioGroupProps<T>
>;

interface FormCheckboxGroupComponent {
  <T = string>(props: FormRadioGroupPropsWithChildren<T>): ReactElement;
  Item: typeof FormCheckboxGroupItem;
}

export const FormCheckboxGroup: FormCheckboxGroupComponent = ({
  children,
  ...props
}) => {
  return (
    <FormControl variant="list" type="checkboxGroup" {...props}>
      {({ value = [], onChange }) => {
        return (
          <FormCheckboxGroupContext.Provider
            value={{ values: value, onChange }}
          >
            <IonItemGroup>{children}</IonItemGroup>
          </FormCheckboxGroupContext.Provider>
        );
      }}
    </FormControl>
  );
};

FormCheckboxGroup.Item = FormCheckboxGroupItem;
